export default "__VITE_ASSET__CG1FNC6z__"